import { stepsFullPath } from "../stepsPath";
import { TherapistFields } from "../util";

export const coveredFields: TherapistFields = ["business_info"];
export const step2Path = "/2";
export const step2FullPath = `${stepsFullPath}${step2Path}`;
export const step2Caption = "Business Info";
